import { Directive, Injector } from '@angular/core';
import { AbstractControl, FormControl, Validators } from '@angular/forms';
import { ApBaseClass, SystemGuid } from 'webcommon/shared';

import { FcListValidationService } from '../fc-list-validation/fc-list-validation.service';
import { FindControlIdService } from 'webcommon/legacy-common';

@Directive()
export class FcItemListBaseComponent extends ApBaseClass {
  public readonly fcListValidation: FcListValidationService;
  public readonly systemGuid: SystemGuid;
  public readonly findControlIdService: FindControlIdService;
  public readonly FindControlIdService = FindControlIdService;

  constructor(injector: Injector) {
    super();
    this.fcListValidation = injector.get(FcListValidationService);
    this.systemGuid = injector.get(SystemGuid);
    this.findControlIdService = injector.get(FindControlIdService);
  }

  public showErrors(control: AbstractControl, isSubmitted: boolean = false): boolean {
    return FcListValidationService.showErrors(control, isSubmitted);
  }

  public getFindControlValue(value: string | string[]): string[] {
    const newSelectedPks: string[] = Array.isArray(value)
      ? [...value.filter(pk => typeof pk === 'string' && pk.length > 0)]
      : typeof value === 'string' && value.length > 0
      ? [value]
      : [];
    return newSelectedPks;
  }

  public parseFindControlValue(value: string | string[], multiselect?: false): string;
  public parseFindControlValue(value: string | string[], multiselect?: true): string[];
  public parseFindControlValue(value: string | string[], multiselect: boolean = false): string | string[] {
    if (Array.isArray(value) && value.length > 0) {
      return multiselect ? value : value[0];
    } else if (typeof value === 'string' && value.length > 0) {
      return multiselect ? [value] : value;
    }
    return multiselect ? [] : this.systemGuid.GuidEmpty;
  }

  public isRequired(control: FormControl): boolean {
    return control.hasValidator(Validators.required);
  }
}
